<template>
  <div>
    <div v-if="$store.state.patient.selectedPatient" class="monitor">
      <div class="left-side">
        <PatientProfile
          ref="patientProfile"
          :isCalibrating="
            detail && detail.data ? detail.data.isCalibrating : false
          "
          :calibrationPercentage="
            detail && detail.data ? detail.data.calibrationPercentage : 0
          "
        />
      </div>
      <div class="right-side">
        <div class="monitor-content">
          <div
            class="no-data v-h-center"
            v-if="!detail.data && $store.state.patient.selectedPatient"
            v-loading="loading"
          >
            <div>
              <div class="mb-10">
                <span v-html="$t('text.monitor_warning')"></span>
                {{ $store.state.patient.selectedPatient.alias }}.
              </div>
              <div>
                {{ $t('text.find_further_information') }}
                <span
                  class="underline blue-font pointer"
                  @click="toInformationForUse()"
                  >{{ $t('text.here') }}</span
                >.
              </div>
            </div>
          </div>
          <div v-else-if="$store.state.patient.selectedPatient && detail.data">
            <el-row class="dashboard-item-wrapper" :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="16">
                <div class="monitor-item-card" v-loading="loading">
                  <div class="pad-card">
                    <div
                      class="current-status-section"
                      :class="getPadInfo().cardClass"
                    >
                      <div class="title">
                        <span>{{
                          $t('text.diaper', {
                            pad: $store.state.locale.pad
                          }).toUpperCase()
                        }}</span>
                      </div>
                      <div class="circle v-h-center mb-20">
                        <div :class="getPadInfo().circleBgClass">
                          <img
                            v-if="getPadInfo().imgSrc"
                            :class="getPadInfo().imgClass"
                            :src="
                              require('../../assets/image/NotificationIcons/' +
                                getPadInfo().imgSrc)
                            "
                          />
                        </div>
                      </div>
                      <el-tooltip placement="top" effect="light">
                        <div slot="content">
                          <div>
                            {{ $t('text.life') }}: {{ detail.data.batteryLife }}
                            {{ $t('text.days') }}
                          </div>
                          <div>
                            {{ $t('text.voltage') }}:
                            {{ detail.data.batteryVoltage }}V
                          </div>
                        </div>
                        <!-- when battery level <=20, show red icon -->
                        <div
                          class="smartz-battery-icon pointer"
                          v-if="
                            detail.data.batteryStatus &&
                              detail.data.podStatus !== 'NODATARECEIVED'
                          "
                        >
                          <div
                            class="smartz-battery-icon-bar"
                            :style="{
                              background:
                                detail.data.batteryLevel <= 20
                                  ? '#DD808C'
                                  : '#8DD749',
                              width: detail.data.batteryLevel + '%'
                            }"
                          ></div>
                        </div>
                      </el-tooltip>
                      <div
                        class="bottom-text"
                        v-if="getPadInfo().bottomText"
                        v-html="getPadInfo().bottomText"
                      ></div>
                      <div
                        class="left-text"
                        v-if="getPadInfo().leftText"
                        v-html="getPadInfo().leftText"
                      ></div>
                      <div
                        class="right-text"
                        v-if="getPadInfo().rightText"
                        v-html="getPadInfo().rightText"
                      ></div>
                    </div>
                    <el-divider></el-divider>
                    <div
                      class="goal-section"
                      v-loading="timeInPadGoalLoading"
                      :class="timeInPadGoalEnabled ? 'active-goal' : ''"
                    >
                      <div class="mb-5">
                        <span>{{ $t('text.goal').toUpperCase() }}</span>
                        <i
                          class="el-icon-edit-outline ml-5"
                          @click="redirectTo('/patients/skin-care-goal')"
                          v-if="
                            timeInPadGoalEnabled &&
                              p('Patients.Goals.SkinCare.View')
                          "
                        ></i>
                        <el-switch
                          :value="timeInPadGoalEnabled"
                          class="switch"
                          :width="switchWidth"
                          active-color="#02a7f0"
                          inactive-color="#D7D7D7"
                          :active-text="$t('text.on').toUpperCase()"
                          :inactive-text="$t('text.off').toUpperCase()"
                          @input="redirectTo('/patients/skin-care-goal')"
                        >
                        </el-switch>
                      </div>
                      <div v-if="timeInPadGoalEnabled">
                        <div
                          v-if="
                            disconnectStatusArr.includes(detail.data.podStatus)
                          "
                        >
                          <img
                            :src="require('@/assets/image/goal-flag-icon.png')"
                          />
                          <span class="ml-10">
                            {{ disconnectStatusDesc[detail.data.podStatus] }}
                          </span>
                        </div>
                        <div v-else>
                          <div class="mb-5">
                            <!-- No matter whether the day goal or the night goal is on, the flag icon is displayed, and only one is displayed  -->
                            <img
                              :class="timeInDryPadGoalEnabled ? '' : 'hidden'"
                              :src="
                                require('@/assets/image/goal-flag-icon.png')
                              "
                            />
                            <div class="goal-desc">
                              <span class="mr-30">
                                {{
                                  $t('text.max_time_in_pad', {
                                    pad: $store.state.locale.pad
                                  })
                                }}
                              </span>
                              <span>
                                <span>
                                  {{ $t('text.day').toLowerCase() }}:
                                  {{
                                    goal.IsDayPadGoalEnabled
                                      ? secondFormat(goal.MaxTimeInPadD)
                                      : $t('text.off')
                                  }}
                                </span>
                                <span
                                  class="active-text"
                                  v-if="getPadSelected() === timePeriod.day"
                                  >({{ $t('text.active') }})</span
                                >
                                <span class="ml-5">
                                  {{ $t('text.night').toLowerCase() }}:
                                  {{
                                    goal.IsNightPadGoalEnabled
                                      ? secondFormat(goal.MaxTimeInPadN)
                                      : $t('text.off')
                                  }}
                                </span>
                              </span>
                              <span
                                class="active-text"
                                v-if="getPadSelected() === timePeriod.night"
                                >({{ $t('text.active') }})</span
                              >
                            </div>
                          </div>
                          <div>
                            <!-- No matter whether the day goal or the night goal is on, the flag icon is displayed, and only one is displayed  -->
                            <img
                              :class="timeInWetPadGoalEnabled ? '' : 'hidden'"
                              :src="
                                require('@/assets/image/goal-flag-icon.png')
                              "
                            />
                            <div class="goal-desc">
                              <span class="mr-30">
                                {{
                                  $t('text.max_time_in_wet_pad', {
                                    pad: $store.state.locale.pad
                                  })
                                }}
                              </span>
                              <span>
                                {{ $t('text.day').toLowerCase() }}:
                                {{
                                  goal.IsDayMaxYellowGoalEnabled
                                    ? secondFormat(goal.MaxTimeInYellowD)
                                    : $t('text.off')
                                }}
                              </span>
                              <span
                                class="active-text"
                                v-if="getPadSelected() === timePeriod.day"
                                >({{ $t('text.active') }})</span
                              >
                              <span class="ml-5">
                                {{ $t('text.night').toLowerCase() }}:
                                {{
                                  goal.IsNightMaxYellowGoalEnabled
                                    ? secondFormat(goal.MaxTimeinYellowN)
                                    : $t('text.off')
                                }}
                              </span>
                              <span
                                class="active-text"
                                v-if="getPadSelected() === timePeriod.night"
                                >({{ $t('text.active') }})</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8">
                <div class="monitor-item-card" v-loading="loading">
                  <div
                    class="current-status-section"
                    :class="getPositionInfo().class"
                  >
                    <div class="title">
                      <span>{{ getPositionInfo().title.toUpperCase() }}</span>
                    </div>
                    <div class="circle v-h-center mb-20">
                      <div class="inner-circle">
                        <img
                          class="w-32"
                          :src="
                            require('../../assets/image/NotificationIcons/' +
                              getPositionInfo().imgSrc)
                          "
                        />
                      </div>
                    </div>
                    <div
                      class="bottom-text"
                      v-html="getPositionInfo().bottomText"
                    ></div>
                    <div
                      class="right-text"
                      v-html="getPositionInfo().rightText"
                    ></div>
                  </div>
                  <el-divider></el-divider>
                  <div
                    class="goal-section"
                    v-loading="timeInPosGoalLoading"
                    :class="timeInPosGoalEnabled ? 'active-goal' : ''"
                  >
                    <div class="mb-5">
                      <span>{{ $t('text.goal').toUpperCase() }}</span>
                      <i
                        class="el-icon-edit-outline ml-5"
                        @click="
                          redirectTo('/patients/position-goal') &&
                            p('Patients.Goals.Position.View')
                        "
                        v-if="timeInPosGoalEnabled"
                      ></i>
                      <el-switch
                        :value="timeInPosGoalEnabled"
                        class="switch"
                        :width="switchWidth"
                        active-color="#02a7f0"
                        inactive-color="#D7D7D7"
                        :active-text="$t('text.on').toUpperCase()"
                        :inactive-text="$t('text.off').toUpperCase()"
                        @input="redirectTo('/patients/position-goal')"
                      >
                      </el-switch>
                    </div>
                    <div v-if="timeInPosGoalEnabled">
                      <div
                        v-if="
                          disconnectStatusArr.includes(detail.data.podStatus)
                        "
                      >
                        <img
                          :src="require('@/assets/image/goal-flag-icon.png')"
                        />
                        <span class="ml-10">
                          {{ disconnectStatusDesc[detail.data.podStatus] }}
                        </span>
                      </div>
                      <div v-else>
                        <div class="mb-5">
                          <img
                            :class="timeInPosGoalEnabled ? '' : 'hidden'"
                            :src="require('@/assets/image/goal-flag-icon.png')"
                          />
                          <span class="goal-desc">
                            <span>
                              {{ $t('text.max_time_in_pos') }} ({{
                                $t('text.day').toLowerCase()
                              }}):
                              {{
                                goal.IsDayPosGoalEnabled
                                  ? secondFormat(goal.MaxTimeInPosD)
                                  : $t('text.off')
                              }}
                            </span>
                            <span
                              class="active-text"
                              v-if="getTimePeriod() === timePeriod.day"
                              >({{ $t('text.active') }})</span
                            >
                          </span>
                        </div>
                        <div>
                          <img
                            class="hidden"
                            :src="require('@/assets/image/goal-flag-icon.png')"
                          />
                          <span class="goal-desc">
                            <span>
                              {{ $t('text.max_time_in_pos') }} ({{
                                $t('text.night').toLowerCase()
                              }}):
                              {{
                                goal.IsNightPosGoalEnabled
                                  ? secondFormat(goal.MaxTimeInPosN)
                                  : $t('text.off')
                              }}
                            </span>
                            <span
                              class="active-text"
                              v-if="getTimePeriod() === timePeriod.night"
                              >({{ $t('text.active') }})</span
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8">
                <div class="monitor-item-card" v-loading="loading">
                  <div
                    class="current-status-section"
                    :class="getTemperatureInfo().class"
                  >
                    <div class="title">
                      <span>{{
                        getTemperatureInfo().title.toUpperCase()
                      }}</span>
                    </div>
                    <div class="circle v-h-center mb-20">
                      <div class="inner-circle">
                        <img
                          class="w-22"
                          :src="
                            require('../../assets/image/NotificationIcons/' +
                              getTemperatureInfo().imgSrc)
                          "
                        />
                      </div>
                    </div>
                    <div class="bottom-text">
                      <span>{{ getTemperatureInfo().bottomText }}</span>
                      <div
                        class="inline-block w-20 h-20"
                        v-if="
                          detail.data.temperatureStatus === 'GREEN' &&
                            !detail.data.isTempStable
                        "
                        v-loading="!detail.data.isTempStable"
                        element-loading-spinner="el-icon-loading"
                      ></div>
                    </div>
                    <div class="right-text">
                      <span
                        v-html="getTemperatureInfo().rightTextFirstLine"
                      ></span>
                      <div
                        v-if="
                          detail.data.temperatureStatus === 'RED' &&
                            !detail.data.isTempStable
                        "
                        class="inline-block w-20 h-20"
                        v-loading="!detail.data.isTempStable"
                        element-loading-spinner="el-icon-loading"
                      ></div>
                      <div
                        v-html="getTemperatureInfo().rightTextSecondLine"
                      ></div>
                    </div>
                  </div>
                  <el-divider></el-divider>
                  <div
                    class="goal-section"
                    v-loading="tempGoalLoading"
                    :class="temperatureGoalEnabled ? 'active-goal' : ''"
                  >
                    <div class="mb-5">
                      <span>{{ $t('text.goal').toUpperCase() }}</span>
                      <i
                        class="el-icon-edit-outline ml-5"
                        @click="
                          redirectTo('/patients/temperature-goal') &&
                            p('Patients.Goals.Temperature.View')
                        "
                        v-if="temperatureGoalEnabled"
                      ></i>
                      <el-switch
                        :value="temperatureGoalEnabled"
                        class="switch"
                        :width="switchWidth"
                        active-color="#02a7f0"
                        inactive-color="#D7D7D7"
                        :active-text="$t('text.on').toUpperCase()"
                        :inactive-text="$t('text.off').toUpperCase()"
                        @input="redirectTo('/patients/temperature-goal')"
                      >
                      </el-switch>
                    </div>
                    <div v-if="temperatureGoalEnabled">
                      <div
                        v-if="
                          disconnectStatusArr.includes(detail.data.podStatus)
                        "
                      >
                        <img
                          :src="require('@/assets/image/goal-flag-icon.png')"
                        />
                        <span class="ml-10">
                          {{ disconnectStatusDesc[detail.data.podStatus] }}
                        </span>
                      </div>
                      <div v-else>
                        <img
                          :class="goal.IsTempGoalEnabled ? '' : 'hidden'"
                          :src="require('@/assets/image/goal-flag-icon.png')"
                        />
                        <span class="goal-desc">
                          <span>
                            {{ $t('text.temp') }} : {{ goal.MinTemp
                            }}{{ goal.tempUnit || 'C' }} - {{ goal.MaxTemp
                            }}{{ goal.tempUnit || 'C' }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8">
                <div class="monitor-item-card" v-loading="loading">
                  <div
                    class="current-status-section"
                    :class="getPadFillProfileInfo().class"
                  >
                    <div class="title">
                      <span>{{
                        getPadFillProfileInfo().title.toUpperCase()
                      }}</span>
                    </div>
                    <div class="circle v-h-center mb-20">
                      <div>
                        <img
                          style="margin-top: -5px"
                          :src="
                            require('../../assets/image/NotificationIcons/' +
                              getPadFillProfileInfo().drop2ImgSrc)
                          "
                        />
                        <img
                          style="margin-left: -18px;"
                          :src="
                            require('../../assets/image/NotificationIcons/' +
                              getPadFillProfileInfo().drop1ImgSrc)
                          "
                        />
                      </div>
                    </div>
                    <div
                      class="bottom-text"
                      v-html="getPadFillProfileInfo().bottomText"
                    ></div>
                  </div>
                  <el-divider></el-divider>
                  <div
                    class="goal-section"
                    v-loading="padFillProfileGoalLoading"
                    :class="padFillProfileGoalEnabled ? 'active-goal' : ''"
                  >
                    <div class="mb-5">
                      <span>{{ $t('text.goal').toUpperCase() }}</span>
                      <i
                        class="el-icon-edit-outline ml-5"
                        @click="
                          redirectTo('/patients/pad-fill-profile-goal') &&
                            p('Patients.Goals.FillProfile.View')
                        "
                        v-if="padFillProfileGoalEnabled"
                      ></i>
                      <el-switch
                        :value="padFillProfileGoalEnabled"
                        class="switch"
                        :width="switchWidth"
                        active-color="#02a7f0"
                        inactive-color="#D7D7D7"
                        :active-text="$t('text.on').toUpperCase()"
                        :inactive-text="$t('text.off').toUpperCase()"
                        @input="redirectTo('/patients/pad-fill-profile-goal')"
                      >
                      </el-switch>
                    </div>
                    <div v-if="padFillProfileGoalEnabled">
                      <div
                        v-if="
                          disconnectStatusArr.includes(detail.data.podStatus)
                        "
                      >
                        <img
                          :src="require('@/assets/image/goal-flag-icon.png')"
                        />
                        <span class="ml-10">
                          {{ disconnectStatusDesc[detail.data.podStatus] }}
                        </span>
                      </div>
                      <div v-else>
                        <div class="mb-5">
                          <img
                            :class="padFillProfileGoalEnabled ? '' : 'hidden'"
                            :src="require('@/assets/image/goal-flag-icon.png')"
                          />
                          <span class="goal-desc">
                            <span>
                              {{ $t('text.day') }}:
                              {{
                                goal.IsDayGoalVolEnabled
                                  ? goal.DayGoalVol + 'ml'
                                  : $t('text.off')
                              }}
                            </span>
                            <span
                              class="active-text"
                              v-if="getTimePeriod() === timePeriod.day"
                              >({{ $t('text.active') }})</span
                            >
                          </span>
                        </div>
                        <div>
                          <img
                            class="hidden"
                            :src="require('@/assets/image/goal-flag-icon.png')"
                          />
                          <span class="goal-desc">
                            <span>
                              {{ $t('text.night').toLowerCase() }}:
                              {{
                                goal.IsNightGoalVolEnabled
                                  ? goal.NightGoalVol + 'ml'
                                  : $t('text.off')
                              }}
                            </span>
                            <span
                              class="active-text"
                              v-if="getTimePeriod() === timePeriod.night"
                              >({{ $t('text.active') }})</span
                            >
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8">
                <div
                  class="monitor-item-card"
                  v-loading="loading"
                  :class="getFallInfo().cardClass"
                >
                  <div
                    class="current-status-section"
                    :class="getFallInfo().class"
                  >
                    <FallSilence :detail="detail" />
                    <div class="title">
                      {{ getFallInfo().title.toUpperCase() }}
                    </div>
                    <div
                      class="circle v-h-center mb-20"
                      :class="getFallInfo().innerCircleClass"
                    >
                      <img
                        class="w-50"
                        :src="
                          require('../../assets/image/NotificationIcons/' +
                            getFallInfo().imgSrc)
                        "
                      />
                    </div>
                    <div
                      class="bottom-text"
                      v-html="getFallInfo().bottomText"
                    ></div>
                  </div>
                  <el-divider></el-divider>
                  <div
                    class="goal-section"
                    v-loading="fallGoalLoading"
                    :class="fallGoalEnabled ? 'active-goal' : ''"
                  >
                    <div class="mb-5">
                      <span>{{ $t('text.goal').toUpperCase() }}</span>
                      <i
                        class="el-icon-edit-outline ml-5"
                        @click="
                          redirectTo('/patients/fall-detection-goal') &&
                            p('Patients.Goals.Fall.View')
                        "
                        v-if="fallGoalEnabled"
                      ></i>
                      <el-switch
                        :value="fallGoalEnabled"
                        class="switch"
                        :width="switchWidth"
                        active-color="#02a7f0"
                        inactive-color="#D7D7D7"
                        :active-text="$t('text.on').toUpperCase()"
                        :inactive-text="$t('text.off').toUpperCase()"
                        @input="redirectTo('/patients/fall-detection-goal')"
                      >
                      </el-switch>
                    </div>
                    <div v-if="fallGoalEnabled">
                      <div
                        v-if="
                          disconnectStatusArr.includes(detail.data.podStatus)
                        "
                      >
                        <img
                          :src="require('@/assets/image/goal-flag-icon.png')"
                        />
                        <span class="ml-10">
                          {{ disconnectStatusDesc[detail.data.podStatus] }}
                        </span>
                      </div>
                      <div v-else>
                        <img
                          :class="goal.IsFallGoalEnabled ? '' : 'hidden'"
                          :src="require('@/assets/image/goal-flag-icon.png')"
                        />
                        <span class="goal-desc">
                          <span>
                            {{ $t('text.detect_falls').toLowerCase() }}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="no-data mt-5" v-else v-loading="loading"></div>
        </div>
      </div>
    </div>
    <NoPatient v-else />
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import moment from 'moment'
import FallSilence from '@/components/patients/FallSilence.vue'
import PatientProfile from '@/components/patients/PatientProfile.vue'
import NoPatient from '@/components/patients/NoPatient'
import { timePeriod, batteryStatus } from '../../const'

export default {
  data() {
    return {
      moment,
      timePeriod,
      batteryStatus,
      userLang: navigator.language || navigator.userLanguage,
      detail: {},
      goalTimer: '',
      loading: false,
      disconnectStatusArr: [
        'DISCONNECTED',
        'NODATARECEIVED',
        'SENSORDISCONNECTED',
        'CHECKCONNECTION'
      ],
      disconnectStatusDesc: {
        DISCONNECTED: this.$t('text.disconnected_desc', {
          pad: this.$store.state.locale.pad
        }),
        NODATARECEIVED: this.$t('text.pod_unclipped_desc'),
        SENSORDISCONNECTED: this.$t('text.apply_sensor_desc'),
        CHECKCONNECTION: this.$t('text.check_connection_desc')
      },
      timeInPadGoalLoading: false,
      timeInPosGoalLoading: false,
      tempGoalLoading: false,
      padFillProfileGoalLoading: false,
      fallGoalLoading: false
    }
  },
  components: {
    FallSilence,
    PatientProfile,
    NoPatient
  },
  mounted: function() {
    this.getDetail()
    this.goalTimer = setInterval(this.getPatientGoal, 600000)
    this.$hub.$on('patient-status-updated', this.onPatientStatusUpdated)
  },
  computed: {
    switchWidth() {
      let width = 55
      if (this.$store.state.locale.currentLocale === 'nl') {
        width = 90
      }
      return width
    },
    goal() {
      return this.$store.state.patient.selectedPatientGoal
    },
    historyData() {
      return this.$store.state.patient.selectedPatientData
    },
    getTimePeriod() {
      return function() {
        if (
          this.$refs.patientProfile.data &&
          this.$refs.patientProfile.data.patientProfile
        ) {
          return this.$refs.patientProfile.data.patientProfile.Time
        }
        return null
      }
    },
    getPadSelected() {
      return function() {
        if (
          this.$refs.patientProfile.data &&
          this.$refs.patientProfile.data.patientProfile
        ) {
          return this.$refs.patientProfile.data.patientProfile.PadSelected
        }
        return null
      }
    },
    secondFormat() {
      return function(num) {
        if (!num) return '0min'
        let str = ''
        let day = Math.floor(num / 86400)
        let hour = Math.floor((num - day * 86400) / 3600)
        let mimute = Math.floor((num - day * 86400 - hour * 3600) / 60)
        if (day) {
          str = str + day + 'd '
        }
        if (hour) {
          str = str + hour + 'h '
        }
        if (mimute) {
          str = str + mimute + 'min'
        }
        return str
      }
    },
    calcTime() {
      return time => {
        let num = moment().diff(moment.utc(time), 'seconds')
        return this.secondFormat(num)
      }
    },
    getPadInfo() {
      return () => {
        let info
        let podStatus = this.detail.data.podStatus
        let padStatus = this.detail.data.padStatus
        let padCycleStartTime = this.detail.data.padCycleStartTime
        let isLikelyInBin = this.detail.data.isLikelyInBin
        if (isLikelyInBin) {
          info = {
            imgSrc: 'pad-in-bin.png',
            imgClass: 'w-32',
            bottomText: this.$t('text.check_bin').toUpperCase(),
            leftText: '',
            rightText:
              this.$t('text.total_time').toUpperCase() +
              '<br />' +
              this.calcTime(padCycleStartTime),
            circleBgClass: 'light-red-bg inner-circle',
            cardClass: 'red-status'
          }
        } else if (podStatus === 'DISCONNECTED') {
          info = {
            imgSrc: 'pod-unclipped.png',
            imgClass: 'w-48 mb-5',
            bottomText: this.$t('text.reclip_pod').toUpperCase(),
            leftText: this.$t('text.pod_unclipped').toUpperCase(),
            circleBgClass: 'inner-circle',
            cardClass: 'grey-status'
          }
        } else if (podStatus === 'CHECKCONNECTION') {
          info = {
            imgSrc: 'pod-unclipped.png',
            imgClass: 'w-48 mb-5',
            bottomText: this.$t('text.reclip_pod').toUpperCase(),
            leftText: this.$t('text.loosely_connected').toUpperCase(),
            circleBgClass: 'inner-circle',
            cardClass: 'grey-status'
          }
        } else if (podStatus === 'SENSORDISCONNECTED') {
          info = {
            imgSrc: 'sensor-disconnected-dark-grey.png',
            imgClass: 'w-44 mb-5',
            bottomText: this.$t('text.apply_sensor').toUpperCase(),
            leftText: '',
            circleBgClass: 'inner-circle',
            cardClass: 'grey-status'
          }
        } else if (podStatus === 'NODATARECEIVED') {
          info = {
            imgSrc: 'wifi-lost-svgrepo-com.svg',
            imgClass: 'w-48',
            bottomText: this.$t('text.find_patient', {
              patient: this.$store.state.locale.patient
            }).toUpperCase(),
            leftText: this.$t('text.lost_connect').toUpperCase(),
            circleBgClass: 'inner-circle',
            cardClass: 'grey-status'
          }
        } else if (['RED', 'MAXCAPACITY'].includes(podStatus)) {
          // MAXCAPACITY behave same as RED
          info = {
            imgSrc: 'pad.svg',
            imgClass: 'w-42',
            bottomText: this.$t('text.change').toUpperCase(),
            leftText: '',
            rightText:
              this.$t('text.total_time').toUpperCase() +
              '<br />' +
              this.calcTime(padCycleStartTime),
            circleBgClass: 'light-red-bg inner-circle',
            cardClass: 'red-status'
          }
        } else if (podStatus === 'PADUNKNOWN') {
          info = {
            imgSrc: 'diaper-not-use.png',
            imgClass: 'w-48 ml-5 mt-5',
            bottomText: this.$t(
              'text.consider_using_smartz_product'
            ).toUpperCase(),
            leftText: this.$t('text.non_smartz_product_in_use').toUpperCase(),
            circleBgClass: 'inner-circle',
            cardClass: 'grey-status'
          }
        } else if (podStatus === 'PADNOTSELECTED') {
          info = {
            imgSrc: 'pad-not-selected.png',
            imgClass: 'w-48 ml-5 mt-5',
            bottomText: this.$t('text.assign_smartz_product_to_patient', {
              patient: this.$store.state.locale.patient
            }).toUpperCase(),
            leftText: this.$t('text.product_not_selected').toUpperCase(),
            circleBgClass: 'inner-circle',
            cardClass: 'grey-status'
          }
        } else if (podStatus === 'ANALYSING') {
          info = {
            imgSrc: 'analysing-pad.png',
            imgClass: 'w-48',
            bottomText: this.$t('text.wait_a_moment').toUpperCase(),
            leftText: this.$t('text.analysing_pad', {
              pad: this.$store.state.locale.pad
            }).toUpperCase(),
            circleBgClass: 'inner-circle',
            cardClass: 'grey-status'
          }
        } else if (podStatus === 'LOWBATTERY') {
          info = {
            imgSrc: 'replace-battery.png',
            imgClass: 'w-62',
            bottomText: this.$t('text.replace_battery').toUpperCase(),
            leftText: this.$t('text.low_battery').toUpperCase(),
            rightText:
              this.$t('text.total_time').toUpperCase() +
              '<br />' +
              this.calcTime(padCycleStartTime),
            circleBgClass: 'inner-circle',
            cardClass: 'red-status'
          }
        } else if (podStatus === 'FLATBATTERY') {
          info = {
            imgSrc: 'flat-battery.png',
            imgClass: 'w-62',
            bottomText: this.$t('text.replace_battery').toUpperCase(),
            leftText: this.$t('text.flat_battery').toUpperCase(),
            rightText:
              this.$t('text.total_time').toUpperCase() +
              '<br />' +
              this.calcTime(padCycleStartTime),
            circleBgClass: 'inner-circle',
            cardClass: 'red-status'
          }
        } else if (padStatus === 'RED') {
          let padStatusTrigger = this.detail.data.padStatusTrigger
          info = {
            imgSrc: padStatusTrigger
              ? 'time-in-pad-red2.png'
              : 'time-in-pad-red.png',
            imgClass: 'w-40 mt-5',
            bottomText: this.$t('text.change').toUpperCase(),
            leftText:
              padStatusTrigger === 1 || padStatusTrigger === 7
                ? this.$t('text.exceed_goal_time').toUpperCase()
                : padStatusTrigger === 2
                ? this.$t('text.exceed_predicted_time').toUpperCase()
                : padStatusTrigger === 3
                ? this.$t('text.exceed_safe_time').toUpperCase() +
                  '<br />' +
                  this.$t('text.max').toUpperCase() +
                  ': 12h'
                : '',
            rightText:
              this.$t('text.total_time').toUpperCase() +
              '<br />' +
              this.calcTime(padCycleStartTime),
            circleBgClass: 'light-red-border inner-circle',
            cardClass: 'red-status'
          }
        } else if (podStatus === 'YELLOW') {
          info = {
            imgSrc: 'pad.svg',
            imgClass: 'w-42',
            bottomText: '',
            leftText: '',
            rightText:
              this.$t('text.total_time').toUpperCase() +
              '<br />' +
              this.calcTime(padCycleStartTime),
            circleBgClass: 'yellow-circle inner-circle',
            cardClass: 'grey-status'
          }
        } else if (
          [
            'CLUMPED-GREEN',
            'CLUMPED-YELLOW',
            'CLUMPED',
            'UNSTABLE',
            'GREEN',
            'WETSURFACE'
          ].includes(podStatus)
        ) {
          info = {
            imgSrc: 'pad.svg',
            imgClass: 'w-42',
            bottomText: this.$t('text.ok').toUpperCase(),
            leftText: '',
            rightText:
              this.$t('text.total_time').toUpperCase() +
              '<br />' +
              this.calcTime(padCycleStartTime),
            circleBgClass: 'dark-green-bg inner-circle',
            cardClass: 'grey-status'
          }
        } else {
          info = {
            imgSrc: 'pad.svg',
            imgClass: 'w-42',
            bottomText: this.$t('text.ok').toUpperCase(),
            leftText: '',
            rightText:
              this.$t('text.total_time').toUpperCase() +
              '<br />' +
              this.calcTime(padCycleStartTime),
            circleBgClass: 'dark-green-bg inner-circle',
            cardClass: 'grey-status'
          }
        }
        return info
      }
    },
    getPositionInfo() {
      //Icon will go red if Day is active and Day Goal has been reached, same for Night. If Time in position goal is active but goal has not been reached icon is green. If position goal is not active or pod is unclipped icon is grey
      return () => {
        let info
        if (
          this.disconnectStatusArr.includes(this.detail.data.podStatus) ||
          !this.detail.data.positionStatus
        ) {
          info = {
            title: this.$t('text.time_in_position'),
            imgSrc: 'body-position-grey.svg',
            class: 'grey-status',
            bottomText:
              this.detail.data.podStatus === 'CHECKCONNECTION'
                ? this.$t('text.checking_connection').toUpperCase()
                : this.$t('text.lost_connect').toUpperCase(),
            rightText: null
          }
        } else if (this.detail.data.positionStatus === 'RED') {
          info = {
            title: this.$t('text.time_in_position'),
            imgSrc: 'body-position-red.svg',
            class: 'red-status',
            bottomText: this.$t('text.change_position').toUpperCase(),
            rightText: this.detail.data
              ? this.detail.data.positionForRed +
                '<br/>' +
                this.calcTime(this.detail.data.startTimeForRedPos)
              : null
          }
        } else {
          info = {
            title: this.$t('text.time_in_position'),
            imgSrc: 'body-position-green.svg',
            class: 'green-status',
            bottomText: this.detail.data
              ? this.detail.data.position +
                ' | ' +
                this.calcTime(this.detail.data.startTimeInCurrentPosition)
              : null,
            rightText: null
          }
        }
        return info
      }
    },
    getTemperatureInfo() {
      return () => {
        let info
        if (
          this.disconnectStatusArr.includes(this.detail.data.podStatus) ||
          !this.detail.data.temperatureStatus
        ) {
          info = {
            title: this.$t('text.surrounding_temperature'),
            imgSrc: 'temperature-grey.svg',
            class: 'grey-status',
            bottomText:
              this.detail.data.podStatus === 'CHECKCONNECTION'
                ? this.$t('text.checking_connection').toUpperCase()
                : this.$t('text.lost_connect').toUpperCase(),
            rightTextFirstLine: null,
            rightTextSecondLine: null
          }
        } else if (this.detail.data.temperatureStatus === 'RED') {
          info = {
            title: this.$t('text.surrounding_temperature'),
            imgSrc: 'temperature-red.svg',
            class: 'red-status',
            bottomText: this.$t('text.check_temperture').toUpperCase(),
            rightTextFirstLine: this.detail.data
              ? this.detail.data.currentTemperature +
                (this.detail.data.tempUnit || 'C')
              : null,
            rightTextSecondLine: this.detail.data
              ? this.calcTime(this.detail.data.startTimeForRedTemp)
              : null
          }
        } else {
          info = {
            title: this.$t('text.surrounding_temperature'),
            imgSrc: 'temperature-green.svg',
            class: 'green-status',
            bottomText: this.detail.data
              ? this.detail.data.currentTemperature +
                (this.detail.data.tempUnit || 'C') +
                ' | ' +
                this.calcTime(this.detail.data.startTimeInCurrentTemperature)
              : null,
            rightTextFirstLine: null,
            rightTextSecondLine: null
          }
        }
        return info
      }
    },
    getPadFillProfileInfo() {
      return () => {
        let info
        let bottomText
        if (this.disconnectStatusArr.includes(this.detail.data.podStatus)) {
          bottomText =
            this.detail.data.podStatus === 'CHECKCONNECTION'
              ? this.$t('text.checking_connection').toUpperCase()
              : this.$t('text.lost_connect').toUpperCase()
        } else {
          bottomText =
            this.$t('text.day').toLowerCase() +
            ': ' +
            (this.historyData.DaytimeAvg || 0) +
            'ml' +
            ' - ' +
            this.$t('text.night').toLowerCase() +
            ': ' +
            (this.historyData.NightTimeAvg || 0) +
            'ml'
        }
        info = {
          title: this.$t('text.pad_fill_profile', {
            pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
          }).toUpperCase(),
          drop1ImgSrc: 'drop1-grey.svg',
          drop2ImgSrc: 'drop2-grey.svg',
          class: 'grey-status',
          bottomText: bottomText
        }
        return info
      }
    },
    getFallInfo() {
      return () => {
        let info
        if (
          this.disconnectStatusArr.includes(this.detail.data.podStatus) ||
          !this.detail.data.fallStatus
        ) {
          info = {
            title: this.$t('text.fall_detection'),
            cardClass: '',
            class: 'grey-status',
            innerCircleClass: '',
            imgSrc: 'attend-fall-grey.png',
            bottomText:
              this.detail.data.podStatus === 'CHECKCONNECTION'
                ? this.$t('text.checking_connection').toUpperCase()
                : this.$t('text.lost_connect').toUpperCase()
          }
        } else if (this.detail.data.fallStatus === 'RED') {
          info = {
            title: this.$t('text.fall_detection'),
            cardClass: 'fall-animate-bg',
            class: 'red-status',
            innerCircleClass: 'white-bg',
            imgSrc: 'attend-fall.png',
            bottomText: this.detail.data
              ? this.$t('text.check_patient', {
                  patient: this.$store.state.locale.patient
                }).toUpperCase() +
                ' | ' +
                this.calcTime(this.detail.data.startTimeForFall)
              : null
          }
        } else if (this.detail.data.fallStatus === 'SILENT') {
          info = {
            title: this.$t('text.fall_detection'),
            cardClass: 'fall-bg',
            class: 'red-status',
            innerCircleClass: 'white-bg',
            imgSrc: 'attend-fall.png',
            bottomText: this.$t('text.silencing').toUpperCase()
          }
        } else {
          // if fall goal enabled, show green status, else show grey status
          if (this.fallGoalEnabled) {
            info = {
              title: this.$t('text.fall_detection'),
              cardClass: '',
              class: 'green-status',
              innerCircleClass: '',
              imgSrc: 'attend-fall-green.png',
              bottomText: this.$t('text.monitoring').toUpperCase()
            }
          } else {
            info = {
              title: this.$t('text.fall_detection'),
              cardClass: '',
              class: 'grey-status',
              innerCircleClass: '',
              imgSrc: 'attend-fall-grey.png',
              bottomText: this.$t('text.not_monitoring').toUpperCase()
            }
          }
        }
        return info
      }
    },
    timeInDryPadGoalEnabled() {
      return (
        this.$store.state.patient.selectedPatientGoal.IsDayPadGoalEnabled ||
        this.$store.state.patient.selectedPatientGoal.IsNightPadGoalEnabled
      )
    },
    timeInWetPadGoalEnabled() {
      return (
        this.$store.state.patient.selectedPatientGoal
          .IsDayMaxYellowGoalEnabled ||
        this.$store.state.patient.selectedPatientGoal
          .IsNightMaxYellowGoalEnabled
      )
    },
    timeInPadGoalEnabled() {
      return this.timeInDryPadGoalEnabled || this.timeInWetPadGoalEnabled
    },
    timeInPosGoalEnabled() {
      return (
        this.$store.state.patient.selectedPatientGoal.IsDayPosGoalEnabled ||
        this.$store.state.patient.selectedPatientGoal.IsNightPosGoalEnabled
      )
    },
    temperatureGoalEnabled() {
      return this.$store.state.patient.selectedPatientGoal.IsTempGoalEnabled
    },
    padFillProfileGoalEnabled() {
      return (
        this.$store.state.patient.selectedPatientGoal.IsDayGoalVolEnabled ||
        this.$store.state.patient.selectedPatientGoal.IsNightGoalVolEnabled
      )
    },
    fallGoalEnabled() {
      return this.$store.state.patient.selectedPatientGoal.IsFallGoalEnabled
    }
  },
  watch: {
    '$store.state.patient.selectedPatient.patientId': function() {
      this.getDetail()
      this.getPatientGoal()
      this.getHistoryData()
    }
  },
  methods: {
    getDetail() {
      if (!this.$store.state.patient.selectedPatient) return false
      this.detail = {}
      this.loading = true
      ApiService.GetPodStatus(
        this.$store.state.patient.selectedPatient.patientId
      )
        .then(response => {
          this.loading = false
          this.detail = response.data || {}
        })
        .catch(() => {
          this.loading = false
          //console.log('IN Catch: ')
        })
    },
    getHistoryData() {
      this.$store.dispatch('patient/getSelectedPatientHistoryData')
    },
    onPatientStatusUpdated(response) {
      if (
        response.patientId ===
        this.$store.state.patient.selectedPatient.patientId
      ) {
        this.detail = {
          ...response,
          alias: this.$store.state.patient.selectedPatient.alias
        }
      }
    },
    getPatientGoal() {
      this.$store.dispatch('patient/getSelectedPatientGoal')
    },
    toInformationForUse() {
      window.open('https://www.smartzhealth.com/user-manual/', '_blank')
    },
    redirectTo(url) {
      this.$router.push(url)
    },
    changeTimeInPadGoal(val) {
      this.timeInPadGoalLoading = true
      ApiService.SaveSkinCareGoal({
        patientId: this.$store.state.patient.selectedPatient.patientId,
        MaxTimeInPadD: val ? 3600 : 0,
        MaxTimeInPadN: val ? 3600 : 0
      })
        .then(response => {
          this.timeInPadGoalLoading = false
          if (response.data.success) {
            this.getPatientGoal()
            this.getHistoryData()
          }
        })
        .catch(() => {
          this.timeInPadGoalLoading = false
        })
    },
    changeTimeInPosGoal(val) {
      this.timeInPosGoalLoading = true
      ApiService.SavePositionGoal({
        patientId: this.$store.state.patient.selectedPatient.patientId,
        MaxTimeInPosD: val ? 3600 : 0,
        MaxTimeInPosN: val ? 3600 : 0
      })
        .then(response => {
          this.timeInPosGoalLoading = false
          if (response.data.success) {
            this.getPatientGoal()
            this.getHistoryData()
          }
        })
        .catch(() => {
          this.timeInPosGoalLoading = false
        })
    },
    changeTempGoal(val) {
      this.tempGoalLoading = true
      ApiService.SaveTemperatureGoal({
        patientId: this.$store.state.patient.selectedPatient.patientId,
        MinTemp: val ? 20 : 0,
        MaxTemp: val ? 45 : 0
      })
        .then(response => {
          this.tempGoalLoading = false
          if (response.data.success) {
            this.getPatientGoal()
            this.getHistoryData()
          }
        })
        .catch(() => {
          this.tempGoalLoading = false
        })
    },
    changePadFillProfileGoal(val) {
      this.padFillProfileGoalLoading = true
      ApiService.SavePadFillProfileGoal({
        patientId: this.$store.state.patient.selectedPatient.patientId,
        DayGoalVol: val ? 100 : 0,
        NightGoalVol: val ? 100 : 0
      })
        .then(response => {
          this.padFillProfileGoalLoading = false
          if (response.data.success) {
            this.getPatientGoal()
            this.getHistoryData()
          }
        })
        .catch(() => {
          this.padFillProfileGoalLoading = false
        })
    },
    changFallGoal(val) {
      this.fallGoalLoading = true
      ApiService.SaveFallGoal({
        patientId: this.$store.state.patient.selectedPatient.patientId,
        IsFallGoalEnabled: !!val
      })
        .then(response => {
          this.fallGoalLoading = false
          if (response.data.success) {
            this.getPatientGoal()
            this.getHistoryData()
          }
        })
        .catch(() => {
          this.fallGoalLoading = false
        })
    }
  },
  beforeDestroy() {
    clearInterval(this.goalTimer)
  }
}
</script>

<style lang="scss" scoped>
.no-data {
  padding: 15px;
  min-height: 300px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}
</style>
